/**
 * ViewSelector — Team / Users segmented control.
 *
 * Uses ButtonGroup (the canonical selection primitive across opsbee web) to
 * match the visual vocabulary of the page-level sub-module ButtonGroup
 * (Store Configuration / Team Management). Two mutually-exclusive view modes —
 * Print is a separate action button in the filter band, not a third view.
 */
import React from 'react';
import { ButtonGroup } from '@pimm/base';
import type { ViewMode } from '../types';

type ViewSelectorProps = {
  value: ViewMode;
  onChange: (next: ViewMode) => void;
  teamLabel: string;
  usersLabel: string;
};

export const ViewSelector = ({ value, onChange, teamLabel, usersLabel }: ViewSelectorProps) => (
  <ButtonGroup value={value} onChange={next => onChange(next as ViewMode)}>
    <ButtonGroup.Item value="team" minW={90}>
      {teamLabel}
    </ButtonGroup.Item>
    <ButtonGroup.Item value="users" minW={90}>
      {usersLabel}
    </ButtonGroup.Item>
  </ButtonGroup>
);

export default ViewSelector;
